export default "__VITE_ASSET__COG4sDgA__"